import { LS_CART_KEY } from '@shared/data';
import { loadLocalCart } from '@shared/utils';
import Joi from 'joi';
const schema = Joi.array().items(Joi.object({
    type: Joi.string().required(),
    angleCount: Joi.number().required(),
    angle2Count: Joi.number().required(),
    angle3Count: Joi.number().required(),
    count: Joi.number().integer().min(0).required(),
    description: Joi.string().required(),
    excelFields: Joi.array().items(Joi.any()),
    framesInfoForExcel: Joi.array().items(Joi.any()),
    price: Joi.string().required(),
    square: Joi.string().required(),
    standardName: Joi.string().required(),
    thickness: Joi.string().required(),
    tire2Len: Joi.number().required(),
    tire3Len: Joi.number().required(),
    tireLength: Joi.number().required(),
    totalPrice: Joi.string(),
    supplierData: Joi.array().items(Joi.string())
}));
class LocalCart {
    static get list() {
        return this.validate(loadLocalCart());
    }
    static get count() {
        return this.list.length;
    }
    static validate(cart) {
        const { error, value, warning } = schema.validate(cart);
        if (error) {
            console.error(error);
            return [];
        }
        if (warning) {
            console.warn(warning);
            return value;
        }
        return value;
    }
    static save(list) {
        localStorage.setItem(LS_CART_KEY, JSON.stringify(list));
    }
    static getItem(index) {
        return this.list.at(index);
    }
    static getItemCount(index) {
        var _a;
        return ((_a = this.list.at(index)) === null || _a === void 0 ? void 0 : _a.count) || 0;
    }
    static addItem(item) {
        this.save([...this.list, item]);
    }
    static changeItem(index, cb) {
        const list = this.list;
        const item = list === null || list === void 0 ? void 0 : list[index];
        if (item !== undefined)
            list[index] = cb(item);
        else
            console.error('Attempt to change a non-existing bucket item!');
        this.save(list);
    }
}
export default LocalCart;
